export const CLIENT_QUERY = 'client-query';

export default interface Query
{
}
